import EDC from '../../shared/globals';
import { AnswerMark } from '../../shared/mark-animation';

/**
 *
 */
EDC.Games.ImagesToTextSpace.Answer = function (scene, config) {
  this.scene = scene;
  this.container = null;
  this.gameConfig = config;
  this.config = config.answer;
  this.size = {
    width: 0,
    height: 0,
  };
  this.data = null;
  this.item = null;
  this.itemScale = 0.33;
  this.zoomScale = 1.1;
  this.tween = null;
  this.isBusy = false;
  this.endX = 0;
  this.endY = 0;
  this.markAnim = null;
  this.isCorrect = false;
  this.cursorManager = scene.cursorManager;

  return this;
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Answer.prototype.create = function () {
  this.container = this.scene.add.container(0, 0);

  const frame = this.scene.add.sprite(0, 0, 'answer-frame');
  this.container.add(frame);

  const bounds = this.container.getBounds();
  this.size.width = bounds.width;
  this.size.height = bounds.height;

  this.container.setSize(this.size.width, this.size.height);
  this.container.setInteractive();
  this.container.on('pointerover', this.pointerOver, this);
  this.container.on('pointerout', this.pointerOut, this);
  this.container.on('pointerup', this.pointerUp, this);

  this.cursorManager.setDefaultDraggableEvents(this.container);

  this.createAndPlaceFrameIcons();

  this.markAnim = new AnswerMark(this.scene, this.container).setScale(0.45);

  return this;
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Answer.prototype.createAndPlaceFrameIcons = function () {
  // const p = EDC.DefaultPositions;
  const index = this.scene.getUnusedFrameIcon();
  const frameIcon = this.scene.add.sprite(0, 0, `frameIcon${index}`);
  this.container.add(frameIcon);
  frameIcon.x -= this.size.width / 2;
  frameIcon.y -= this.size.height / 2;
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Answer.prototype.place = function (x, y, isEndPosition = false) {
  if (isEndPosition) {
    this.endX = x;
    this.endY = y;
  } else {
    this.container.setPosition(x, y);
  }
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Answer.prototype.appear = function () {
  const rndDelay = Math.floor(Math.random() * 200);
  this.scene.tweens.add({
    targets: this.container,
    y: this.endY,
    duration: 500,
    ease: 'Back.easeOut',
    delay: rndDelay,
    onComplete: this.animate.bind(this),
  });
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Answer.prototype.disappear = function () {};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Answer.prototype.checkAnswer = function (questionValue) {
  if (this.data.text === questionValue) {
    console.log('Cool!');
  } else {
    console.log('FAIL :(');
  }
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Answer.prototype.setData = function (data, isCorrect) {
  this.data = data;
  this.isCorrect = isCorrect;
  this.markAnim.reset();
  this.makeInteractive();
  if (this.item) {
    this.fadeItem(0, () => {
      this.isBusy = true;
      this.item.destroy();
      this.addItem();
      this.item.setAlpha(0);
      this.fadeItem(1, () => {
        this.isBusy = false;
      });
    });
  } else {
    this.addItem();
  }
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Answer.prototype.addItem = function () {
  this.item = this.scene.add.sprite(0, 0, this.data.spriteName);
  this.item.setScale(this.itemScale);
  this.container.addAt(this.item, 1);
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Answer.prototype.fadeItem = function (
  targetAlpha,
  onCompleteCallback = () => {
    console.log('default complete');
  },
) {
  this.scene.tweens.add({
    targets: this.item,
    alpha: targetAlpha,
    duration: 80,
    ease: 'Linear',
    onComplete: onCompleteCallback,
  });
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Answer.prototype.makeInteractive = function (isOn = true) {
  if (isOn) {
    this.container.setInteractive();
  } else {
    this.container.removeInteractive();
  }
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Answer.prototype.pointerOver = function () {
  this.zoom(this.zoomScale, 150);
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Answer.prototype.pointerOut = function () {
  this.zoom(1.0, 250);
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Answer.prototype.disableOthers = function () {
  const others = this.scene.answers;
  for (let i = 0; i < others.length; i++) {
    if (others[i] !== this) {
      others[i].makeInteractive(false);
    }
  }
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Answer.prototype.off = function () {};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Answer.prototype.pointerUp = function () {
  if (this.isBusy) return;
  this.isBusy = true;
  if (this.isCorrect) {
    this.disableOthers();
    this.markAnim.showMark(true, () => {
      this.scene.events.emit(this.scene.signals.S_ITEM_CORRECT);
    });
  } else {
    this.markAnim.showMark(false, () => {
      this.zoom(1.0, 250);
      this.makeInteractive(false);
      this.scene.events.emit(this.scene.signals.S_ITEM_WRONG);
    });
  }
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Answer.prototype.zoom = function (targetValue, timeMs) {
  this.scene.tweens.add({
    targets: this.container,
    scaleX: targetValue,
    scaleY: targetValue,
    duration: timeMs,
  });
};
/**
 * Start idle animations if needed.
 * Currently one predefined animation of flying, but in future can be added more animations.
 */
EDC.Games.ImagesToTextSpace.Answer.prototype.animate = function () {
  this.scene.tweens.add({
    targets: this.container,
    y: this.container.y + 50,
    duration: Math.floor(Math.random() * 600) + 2000,
    ease: 'Sine.easeInOut',
    yoyo: true,
    repeat: -1,
  });
};

export default EDC.Games.ImagesToTextSpace.Answer;
